import { ICustomer } from '@app/common';
import { crudEndpointsFactory } from '../crud-endpoints.factory';

interface CustomerExportParams {
  shopIds?: string[];
  optInSMS?: boolean;
  optInEmail?: boolean;
  optInLoyalty?: boolean;
  ageMin?: number;
  ageMax?: number;
  registeredSince?: string;
  lastOrderFrom?: string;
  lastOrderTo?: string;
  minOrdersCount?: number;
  minCA?: number;
  registeredFrom?: string;
  skip?: number;
  take?: number;
}

interface CustomerExportCountResponse {
  total: number;
}

interface CustomerExportResponse {
  rows: string[][];
  count: number;
}

export const customerApi = crudEndpointsFactory<ICustomer>()('customers', 'Customers').injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    exportCount: builder.mutation<CustomerExportCountResponse, CustomerExportParams>({
      query: (params) => ({
        url: 'customers/export-count',
        method: 'POST',
        body: params,
      }),
    }),
    exportCsv: builder.mutation<CustomerExportResponse, CustomerExportParams>({
      query: (params) => ({
        url: 'customers/export-csv',
        method: 'POST',
        body: params,
      }),
    }),
  }),
});